import React, { useState } from "react";

import clim4CastLogo from "assets/imgs/logos/clim4cast.png";
import arsoLogo from "assets/imgs/logos/arso.png";
import geocodisLogo from "assets/imgs/logos/geocodis.png";
import dridanubeLogo from "assets/imgs/logos/dridanube.png";
import lsaSafLogo from "assets/imgs/logos/lsa-saf.png";

import "assets/styles/Home/HomeUI/home-top-bar.css";

import { Tooltip, Modal, ConfigProvider } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const HomeHeader = () => {
    const [isModalOpen, setIsModalOpen] = useState(true);

    const handleClick = () => setIsModalOpen(!isModalOpen);

    return (
        <div id="home-header">

            <Tooltip align="center" placement="bottom" title="Monitoring and forecasting products of the Clim4Cast project">
                <h1>
                    Droughtwatch
                </h1>
            </Tooltip>

            <div id="header-info">

                <section id="logos">
                    <img src={clim4CastLogo} alt="Clim4Cast Logo" />
                </section>

                <section id="about">
                    <button onClick={handleClick} ><InfoCircleOutlined />About</button>

                    <ConfigProvider theme={{
                        components: {
                            Modal: {
                                titleLineHeight: "2em",
                                titleFontSize: "2em"
                            }
                        }
                    }}>
                        <Modal
                            open={isModalOpen}
                            onCancel={handleClick}
                            footer={null}
                            title="DROUGHTWATCH"
                            width={1200}
                            centered
                            styles={{
                                header: {
                                    textAlign: "center",
                                },
                                body: {
                                    fontSize: "1.15em",
                                    fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
                                    color: "#333",
                                },
                            }}

                        >
                            <p
                                id="info-subtitle"
                                style={{
                                    fontSize: "1.1em",
                                    fontWeight: "500",
                                    textAlign: "center",
                                    marginBottom: "1.2em",
                                }}
                            >
                                Monitoring and forecasting products of the Clim4Cast project
                            </p>

                            <p>
                                DroughtWatch is a web application that provides spatial and temporal view of several
                                drought-related datasets and indices, including vegetation and drought indices,
                                precipitation and temperature datasets and it integrates also estimated drought
                                impacts. It was originally developed and maintained by the consortium of the{" "}
                                <a
                                    href="https://dtp.interreg-danube.eu/approved-projects/dridanube"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    DriDanube project
                                </a>
                                . It was previously available on address droughtwatch.eu.
                            </p>

                            <p>
                                The DroughtWatch portal was redesigned and enriched with new data layers in 2025 in
                                the frame of{" "}
                                <a
                                    href="https://www.interreg-central.eu/projects/clim4cast"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Clim4Cast project
                                </a>
                                . Clim4Cast project provides monitoring and forecasting tools for drought (simulated
                                soil moisture anomalies), heat waves (heat index and universal thermal climatic
                                index) and forest fires (fire weather index and fuel moisture). The new version of
                                the web portal was developed and is maintained by{" "}
                                <a
                                    href="https://www.geocodis.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    GeoCodis Ltd
                                </a>
                                .
                            </p>

                            <p style={{ marginTop: "1em" }}>Links to related tools and projects:</p>
                            <ul style={{ paddingLeft: "1.2em", lineHeight: "1.6em" }}>
                                <li>
                                    <a
                                        href="https://drought.emergency.copernicus.eu/tumbo/edo/map/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        EDO
                                    </a>
                                </li>
                                <li>
                                    <a href="https://ado.eurac.edu/" target="_blank" rel="noopener noreferrer">
                                        ADO
                                    </a>
                                </li>
                                <li>
                                    <a href="https://cct.eurac.edu/x-risk-cc" target="_blank" rel="noopener noreferrer">
                                        X-RISK-CC
                                    </a>
                                </li>
                            </ul>

                            <div style={{ textAlign: "center", margin: "2em 0 1em" }}>
                                <a
                                    href="mailto:info@geocodis.si"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    tabIndex={0}
                                    style={{
                                        display: "inline-block",
                                        backgroundColor: "#000",
                                        color: "#fff",
                                        padding: "0.3em 0.7em",
                                        borderRadius: "999px", // <-- pill shape
                                        fontSize: "1em",
                                        textDecoration: "none",
                                        outline: "none",
                                        transition: "box-shadow 0.2s ease",
                                    }}
                                    onFocus={(e) => e.target.style.boxShadow = "0 0 0 3px rgba(24, 144, 255, 0.6)"}
                                    onBlur={(e) => e.target.style.boxShadow = "none"}
                                >
                                    Contact us
                                </a>
                            </div>

                            <hr style={{ margin: "1.5em 0" }} />

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "2em",
                                    flexWrap: "wrap",
                                    marginTop: "1em",
                                }}
                            >
                                <a href="https://www.arso.gov.si/" target="_blank" rel="noopener noreferrer">
                                    <img src={arsoLogo} alt="ARSO Logo" height="50" />
                                </a>
                                <a href="https://www.geocodis.com/" target="_blank" rel="noopener noreferrer">
                                    <img src={geocodisLogo} alt="GeoCodis Logo" height="30" />
                                </a>
                                <a href="https://dtp.interreg-danube.eu/approved-projects/dridanube" target="_blank" rel="noopener noreferrer">
                                    <img src={dridanubeLogo} alt="DriDanube Logo" height="50" />
                                </a>
                                <a href="https://www.eumetsat.int/lsa-saf" target="_blank" rel="noopener noreferrer">
                                    <img src={lsaSafLogo} alt="LSA SAF Logo" height="50" />
                                </a>
                            </div>
                        </Modal>
                    </ConfigProvider>
                </section>

            </div>

        </div>
    );
}

export default HomeHeader;